import React from 'react';
import { CalendarCheck, ChevronLeft } from 'lucide-react';
import { MEDIA } from './media';

export function HeroBanner({ onCtaClick }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10" data-testid="venues-hero-header">
      <img src={MEDIA.stadium_floodlights_night} alt="ملعب بإضاءة كشافات ليلية" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1829] via-[#16233B]/80 to-[#16233B]/40" />
      <div aria-hidden className="absolute -top-10 right-10 h-64 w-64 rounded-full bg-teal-400/20 blur-3xl" />
      <div aria-hidden className="absolute bottom-0 left-10 h-56 w-56 rounded-full bg-[#F54C07]/20 blur-3xl" />

      <div className="relative z-10 flex flex-col items-start gap-5 px-6 py-14 sm:px-10 sm:py-20">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-teal-400/40 bg-teal-400/10 px-3 py-1.5 text-xs font-bold text-teal-300 shadow-[0_0_20px_rgba(20,184,166,0.35)]" data-testid="venues-hero-badge">
          <CalendarCheck className="h-3.5 w-3.5" /> منصّة تسيار لحجز الملاعب
        </span>
        <h1 className="max-w-2xl text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
          حجز الملاعب والمنشآت الرياضية <span className="text-teal-300">بضغطة واحدة</span>
        </h1>
        <p className="max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
          حوّل ملاعب منشأتك إلى مصدر دخل إضافي — تقويم حجوزات ذكي، دفع فوري، وإضاءة كشافات تُدار عن بُعد، كل ذلك داخل تسيار.
        </p>
        <button
          onClick={onCtaClick}
          data-testid="hero-explore-venues-cta"
          className="group flex items-center gap-2 rounded-full bg-[#F54C07] px-6 py-3 text-sm font-bold text-white shadow-[0_10px_30px_rgba(245,76,7,0.4)] transition-transform hover:scale-105 hover:bg-[#FF6B2B]"
        >
          تصفّح الملاعب واحجز الآن
          <ChevronLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
        </button>
      </div>
    </div>
  );
}
